import React from 'react';
import { ItemImage } from '@usepepper/ui/atoms/item-image';
import { Spacing } from '@usepepper/sprout-kit';
import { Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { useSupportInfoMinRowHeight } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-support-info/constants';
import type { LostItemAlert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';

const BORDER_WIDTH = 1;

interface LostItemSupportInfoProps {
  alert: LostItemAlert;
}

export const LostItemSupportInfo: React.FC<LostItemSupportInfoProps> = ({
  alert,
}) => {
  const minRowHeight = useSupportInfoMinRowHeight();
  const subtitle = [alert.externalItemId, alert.packUnit]
    .filter(Boolean)
    .join(' • ');

  return (
    <XStack
      alignItems="center"
      borderColor="$borderPrimary"
      borderRadius="$8"
      borderWidth={BORDER_WIDTH}
      gap="$8"
      minHeight={minRowHeight}
      padding="$8"
    >
      <ItemImage
        alt={alert.displayName}
        cachePolicy="memory-disk"
        imageURLs={alert.photoUrls}
        size={Spacing.SPACE_2XLARGE}
      />
      <YStack flex={1}>
        <Typography
          numberOfLines={1}
          size="$sm"
          textAlign="left"
          variant="label"
        >
          {alert.displayName}
        </Typography>
        {subtitle ? (
          <Typography
            color="$textTertiary"
            numberOfLines={1}
            size="$sm"
            textAlign="left"
            textTransform="capitalize"
          >
            {subtitle}
          </Typography>
        ) : null}
      </YStack>
    </XStack>
  );
};
